import React, { FC } from "react";
import { Trans } from "react-i18next";
import { Ii18nInterpolationObject } from "src/@types/i18next";
import { Link } from "../Link";

interface Props extends Ii18nInterpolationObject {}

export const CustomTrans: FC<Props> = ({ i18nKey, i18nParams }) => (
  <Trans
    i18nKey={i18nKey}
    value={i18nParams}
    components={{
      ul: <ul className="pl-4 list-disc" />,
      ol: <ol className="pl-4 list-decimal" />,
      li: <li />,
      br: <br />,
      strong: <strong />,
      businessCloneLink: (
        <Link href={window.origin} className="underline underline-offset-2" />
      ),
    }}
  />
);
